export default "__VITE_ASSET__CkeE6Xv1__"